import { useFilter } from '../../../filter/hook'
import { useQuery } from 'react-query'
import dataAPI from '../../services/dataAPI'

export default function usePowerFactor() {
    const { filter } = useFilter()
    const powerFactorQuery = useQuery({
        queryKey: ['power-factor', filter],
        queryFn: () => dataAPI.getPowerFactor(filter)
    })

    const lastPowerFactorQuery = useQuery({
        queryKey: ['power-factor-last', filter.device_name],
        queryFn: () => dataAPI.getLastPowerFactor(filter)
    })

  return {
    filter,
    powerFactorQuery: {
        data: powerFactorQuery.data,
        isLoading: powerFactorQuery.isLoading,
        isSuccess: powerFactorQuery.isSuccess,
        isError: powerFactorQuery.isError,
        error: powerFactorQuery.error,
        refetch: powerFactorQuery.refetch,
        isRefetching: powerFactorQuery.isRefetching
    },
    lastPowerFactorQuery: {
        data: lastPowerFactorQuery.data,
        isLoading: lastPowerFactorQuery.isLoading,
        isSuccess: lastPowerFactorQuery.isSuccess,
        isError: lastPowerFactorQuery.isError,
        error: lastPowerFactorQuery.error,
        refetch: lastPowerFactorQuery.refetch,
        isRefetching: lastPowerFactorQuery.isRefetching
    }
  }
}
